export const DEFAULT_FIELD_ERROR = 'Обязательное поле';
export const dateRegexp = /(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19|20)\d\d/;
export const LATIN_SPACES_LIMIT = 3;
